type DataTableProps = {
  rows: Record<string, unknown>[] | undefined;
  /** Message shown when there are no rows. */
  emptyText?: string;
  /** Smaller text/row padding (for dense contexts like modals). */
  dense?: boolean;
  /** CSS max-height (e.g. "16rem") — enables vertical scroll + a sticky header. */
  maxHeight?: string;
};

function cellValue(value: unknown): string {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return JSON.stringify(value);
  return String(value);
}

export default function DataTable({ rows, emptyText = "No results.", dense = false, maxHeight }: DataTableProps) {
  if (!rows || rows.length === 0) {
    return <p className="text-sm text-gray-400">{emptyText}</p>;
  }

  const columns = Object.keys(rows[0]);
  const wrapperClass = maxHeight ? "overflow-auto" : "overflow-x-auto";
  const textClass = dense ? "text-[11px]" : "text-xs";
  const cellY = dense ? "py-1" : "py-2";
  const headY = dense ? "py-1.5" : "py-2";

  return (
    <div className={`rounded-lg border border-gray-200 ${wrapperClass}`} style={maxHeight ? { maxHeight } : undefined}>
      <table className={`min-w-full ${textClass}`}>
        <thead className={`bg-gray-50 ${maxHeight ? "sticky top-0" : ""}`}>
          <tr>
            {columns.map((column) => (
              <th key={column} className={`whitespace-nowrap px-3 ${headY} text-left font-semibold text-gray-600`}>
                {column}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex} className={rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}>
              {columns.map((column) => (
                <td key={column} className={`whitespace-nowrap px-3 ${cellY} text-gray-700`}>
                  {cellValue(row[column])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
